import { DocPage } from '../types';
import { PAGES } from './pages.generated';

/**
 * Every page of the documentation, in reading order. The pages are written as Markdown, one file per page and
 * language under content/<locale>/; scripts/build-docs.mjs turns them into pages.generated.ts.
 */
export const DOC_PAGES: DocPage[] = PAGES;
